import * as echarts from 'echarts';
import { EleResize } from './a.js'
// import zhanjiangMP from "@/assets/get/china.json"
// import _ from 'lodash'

const businessOpportunityManagementEcharts = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        xAxis: [
            {
                show: true,
                splitLine: {
                    show: false,
                },
                type: 'value',
                data: [3, 4, 5, 6, 7],
                axisTick: {
                    show: false,
                    alignWithLabel: false,
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#35F7FF',
                    },
                },
                axisLabel: {
                    interval: 0,
                    show: false,
                    textStyle: {
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                    formatter: function (params) {
                        return params + 3;
                    },
                },
            },
        ],
        yAxis: [
            {
                show: false,
                type: 'category',
            },
        ],
        grid: {
            top: '5%',
            bottom: '0%',
            left: '5%',
            right: '5%'
        },
        series: [
            {
                name: '',
                type: 'bar',
                stack: 'total',
                data: [2],
                barWidth: 24,
                yAxisIndex: 0,
                xAxisIndex: 0,

                label: {
                    normal: {
                        position: [-5, -20],
                        show: false,
                        color: '#fff',
                        fontSize: 15,
                        formatter: function () {
                            return '24';
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        color: '#E04040',
                    },
                },
            },
            {
                name: '',
                type: 'bar',
                stack: 'total',
                data: [3],
                barWidth: 24,
                yAxisIndex: 0,
                xAxisIndex: 0,

                label: {
                    normal: {
                        position: [-5, -20],
                        show: true,
                        color: '#E04040',
                        fontSize: 15,
                        formatter: function () {
                            return '24';
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        color: '#EC6272',
                    },
                },
            },
            {
                name: '',
                type: 'bar',
                stack: 'total',
                data: [3],
                barWidth: 24,
                yAxisIndex: 0,
                xAxisIndex: 0,

                label: {
                    normal: {
                        position: [-5, -20],
                        show: true,
                        color: '#EC6272',
                        fontSize: 15,
                        formatter: function () {
                            return '12';
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        color: '#EC6272CC',
                    },
                },
            },
            {
                name: '',
                type: 'bar',
                stack: 'total',
                data: [4],
                barWidth: 24,
                yAxisIndex: 0,
                xAxisIndex: 0,
                label: {
                    normal: {
                        position: [-5, -20],
                        show: true,
                        color: '#EC6272CC',
                        fontSize: 15,
                        formatter: function () {
                            return '8';
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        color: '#EC627299',
                    },
                },
            },
            {
                name: '',
                type: 'bar',
                stack: 'total',
                data: [1],
                barWidth: 24,
                yAxisIndex: 0,
                xAxisIndex: 0,

                label: {
                    normal: {
                        position: [-5, -20],
                        show: true,
                        color: '#EC627299',
                        fontSize: 15,
                        formatter: function () {
                            return '4';
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        color: '#30B294',
                    },
                },
            },

        ],
    };

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const lineEcharts = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        color: ["#3398DB"],
        tooltip: {
            
            trigger: "axis",
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0 ,
            textStyle: {
                color:'#FFFFFF'
            }
        },
        xAxis: {
            data: ["CF", "VSD", "2BE!", "2BE3/4", "2BEQ", "3BEQ", "4BEQ"],
            splitLine: {
                show: false
            },
            axisLine: {
                show: false

            },
            axisTick: {
                show: false

            }
        },
        yAxis: {

            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        },
        grid: {
            top: '5%',
            bottom: '20%',
            left: '5%',
            right: '5%'
        },
        series: {
            name: "Beijing AQI",
            type: "bar",
            barWidth: 20,
            data: [56, 40, 33, 86, 82, 16, 19]
        }
    }

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}

const workOrderStatisticsEcharts = (options) => {
    let { chartDom,text,list1,
        list2,
        list3,name1,
        name2,
        name3, unit, monthList } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    if (monthList.length == 0) {
        
        myChart.showLoading({
            text: text,
            showSpinner: false,    // 隐藏加载中的转圈动图
            textColor: '#ffffff',
            maskColor: 'rgb(18, 24, 49,0)',
            fontSize: '25px',
            fontWeight: 400,
        });
    }
    let option = {
        tooltip: {
            trigger: "axis",
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0 ,
            textStyle: {
                color:'#FFFFFF'
            }
        },
        legend: {
            right: 'center',
            top: 0,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 37,
           
            data:[name1,name2,name3],
            textStyle: {
                fontSize: 12,
                fontFamily: 'Microsoft YaHei',
                fontWeight: 'normal',
                color: '#FFFFFFA8'
            }
        },
        xAxis: {
            data: monthList,
            splitLine: {
                show: false
            },
            axisLine: {
                show: false

            },
            axisTick: {
                show: false

            }
        },

        yAxis: {
            name:unit,
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        },
        grid: {
            top: '10%',
            bottom: '10%',
            left: '5%',
            right: '5%'
        },
        color: ['#11CABE', '#246CF9','#8371F2'],
        series: [
            {
                name: name1,
                type: "bar",
                barWidth: 20,
                data: list1,
                itemStyle: {
                    borderRadius: [10, 10, 10, 10],
                }
            },{
                name: name2,
                type: "bar",
                barWidth: 20,
                data:list2,
                itemStyle: {
                    borderRadius: [10, 10, 10, 10],
                }
            }, {
                name: name3,
                type: 'line',
                smooth: true,
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(60, 66, 84, 0.70)',
                    borderWidth: 0 ,
                    textStyle: {
                        color:'#FFFFFF'
                    },
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                areaStyle: {
                    opacity: 0.2,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: '#7387AE'
                        },
                        {
                            offset: 1,
                            color: '#3A4A69'
                        }
                    ])
                },
                data: list3
            }]
    }

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}

const opportunityEcharts = (options) => {
    let { chartDom,dataList,unit,allNum } = options;

    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
   
    let textColors = [
        "#11CABE",
        "#50D4CC",
        "#1CAEA5",
        "#0A938A",
        "#158079",
        "#246CF9",
        "#8371F2",

    ]
  
    let option = {
        title: {
            text: allNum+unit,
            top: 'center',
            left: 'center',
            textStyle: {
            color: '#ffffff' ,
                fontSize: 20,
                fontWeight:600
            }
        },
        tooltip: {
            trigger: "item",
            formatter: "{b}\n{c}",
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0 ,
            textStyle: {
                color:'#FFFFFF'
            },
        },
        series: [
            {
                type: "pie",
                center: ["50%", "50%"],
                radius: ["40%", "70%"],
                startAngle: 200,
                itemStyle: {
                    color: (params) => {
                        return textColors[params.dataIndex];
                    },
                    // shadowBlur: this.getFontSize(30),
                    // shadowColor: "rgba(255, 255, 255, 0.3)",
                },
                // label: {
                //     show: true,
                //     formatter: (params) => {
                //         let color = "white";
                //         let showText = `${params.name}`;
                //         if (params.dataIndex === 0) {
                //             color = "white";
                //             showText = `{${color}|${params.name}}`;
                //         } else if (params.dataIndex === 1) {
                //             color = "white1";
                //             showText = `{${color}|${params.name}}`;
                //         } else if (params.dataIndex === 2) {
                //             color = "white2";
                //             showText = `{${color}|${params.name}}`;
                //         } else if (params.dataIndex === 3) {
                //             color = "white3";
                //             showText = `{${color}|${params.name}}`;
                //         } else if (params.dataIndex === 4) {
                //             color = "white4";
                //             showText = `{${color}|${params.name}}`;
                //         } else if (params.dataIndex === 5) {
                //             color = "white5";
                //             showText = `{${color}|${params.name}}`;
                //         } else if (params.dataIndex === 6) {
                //             color = "white6";
                //             showText = `{${color}|${params.name}}`;
                //         }
                //         const circle =
                //             "hr" +
                //             color.slice(0, 1).toUpperCase() +
                //             color.slice(1).toLowerCase();
                //         return `${showText}\n{${circle}|}\n{${color}|${params.value}% (${params.value}${unit})}`;
                //     },
                //     color: "#fff",
                //     fontSize: 24,
                //     lineHeight: 20,

                //     rich: {
                //         white: {
                //             color: "white",
                //             fontSize: 15,
                //             padding: [3, -100, 0, -100],
                //         },
                //         white1: {
                //             color: "white",
                //             fontSize: 15,
                //             padding: [3, -100, 0, -100],
                //         },
                //         white2: {
                //             color: "white",
                //             fontSize: 15,
                //             padding: [3, -100, 0, -100],
                //         },
                //         white3: {
                //             color: "white",
                //             fontSize: 15,
                //             padding: [3, -100, 0, -100],
                //         },
                //         white4: {
                //             color: "white",
                //             fontSize: 15,
                //             padding: [3, -100, 0, -100],
                //         },
                //         white5: {
                //             color: "white",
                //             fontSize: 15,
                //             padding: [3, -100, 0, -100],
                //         },
                //         white6: {
                //             color: "white",
                //             fontSize: 15,
                //             padding: [3, -100, 0, -100],
                //         },
                //         hrWhite: {
                //             backgroundColor: textColors[0],
                //             borderRadius: 3,
                //             width: 3,
                //             height: 3,
                //             padding: [3, 3, 0, -12],
                //         },
                //         hrWhite1: {
                //             backgroundColor: textColors[1],
                //             borderRadius: 3,
                //             width: 3,
                //             height: 3,
                //             padding: [3, 3, 0, -12],
                //         },
                //         hrWhite2: {
                //             backgroundColor: textColors[2],
                //             borderRadius: 3,
                //             width: 3,
                //             height: 3,
                //             padding: [3, 3, 0, -12],
                //         },
                //         hrWhite3: {
                //             backgroundColor: textColors[3],
                //             borderRadius: 3,
                //             width: 3,
                //             height: 3,
                //             padding: [3, 3, 0, -12],
                //         },
                //         hrWhite4: {
                //             backgroundColor: textColors[4],
                //             borderRadius: 3,
                //             width: 3,
                //             height: 3,
                //             padding: [3, 3, 0, -12],
                //         },
                //         hrWhite5: {
                //             backgroundColor: textColors[5],
                //             borderRadius: 3,
                //             width: 3,
                //             height: 3,
                //             padding: [3, 3, 0, -12],
                //         },
                //         hrWhite6: {
                //             backgroundColor: textColors[6],
                //             borderRadius: 3,
                //             width: 3,
                //             height: 3,
                //             padding: [3, 3, 0, -12],
                //         },
                //     },
                // },
                // labelLine: {
                //     length: 30,
                //     length2: 90,
                //     lineStyle: {
                //         width: 1,
                //     },
                // },
                label: {
                    alignTo: 'edge',
                    formatter: '{name|{b}}\n{time|{d}}%({time|{c}})',
                    minMargin: 5,
                    edgeDistance: 10,
                    color: "#fff",
                    lineHeight: 15,
                    rich: {
                      time: {
                        fontSize: 10,
                        color: '#ffffff'
                      }
                    }
                  },
                  labelLine: {
                    length: 15,
                    length2: 0,
                    maxSurfaceAngle: 80
                  },
                     labelLayout: function (params) {
            const isLeft = params.labelRect.x < myChart.getWidth() / 2;
            const points = params.labelLinePoints;
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points
            };
          },
                data: dataList,
                z: 0,
            },
        ],
    };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const scheduleEcharts = (options) => {
    let { chartDom,dataList } = options;

    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
   let option = {
        grid: {
           left: 15,
           top: 20,
           bottom: 0,
           right: 0,
           containLabel: true,
        },
        xAxis: {
           show: false,
           type: 'value',
           boundaryGap: [0, 0],
        },
        yAxis: [
           {
              type: 'category',
              axisLine: { show: false },
              axisTick: [
                 {
                    show: false,
                 },
              ],
              axisLabel: {
                 show: false
              }
           },
        ],
        series: [
           {
              name:'进度部分',
              type: 'bar',
              zlevel: 1,
              itemStyle: {
                 normal: {
                      color: '#11CABE',
                      borderRadius: [10, 10, 10, 10],
                     
                 },
              },
              barWidth:10,
              data: [dataList],
           },
           {
              name: '背景部分',
              type: 'bar',
              barWidth: 10,
              barGap: '-100%',
              data: [100],
              itemStyle: {
                 normal: {
                    color: '#D0DEEE',
                      opacity: 0.1,
                      borderRadius: [10, 10, 10, 10],
                    
                 },
              },
           },
           // 进度条的小圆圈
          {
                 name: '小圈圈',
                 type: 'scatter',
                 emphasis: {
                   scale: false
                 },
                 symbol: 'image://data:image/png;base64,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',
                 symbolSize: [30, 30],
                 itemStyle: {
                   color: '#FFF',
                   shadowColor: 'rgba(255, 255, 255, 1)',
                   shadowBlur: 5,
                   borderWidth: 1,
                     opacity: 1,
                 },
                 z: 2,
                 zlevel: 10,
                 data: [dataList],
                 animationDelay: 500
               }
        ],
   };
   var listener = () => {
    myChart.resize()
}
EleResize.on(chartDom, listener)
myChart.clear()
myChart && option && myChart.setOption(option)
}
const pieEcharts = (options) => {
    let { chartDom, dataList, title, color } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        title: [
            {
                text: dataList + '%',
                top: '30%',
                right: 'center',
                textStyle: {
                    color: '#FFFFFF',
                    fontSize: 20,
                    fontWeight: '500',
                },
            },
            {
                text: title,
                top: '47%',
                right: 'center',
                textStyle: {
                    color: '#FFFFFF',
                    fontSize: 15,
                    fontWeight: '400',
                },
            }
        ],
        legend: { show: false },
        series: [
            {
                name: '',
                type: 'pie',
                radius: ['0%', '87%'],
                hoverAnimation: false,
                color: color,
                label: {
                    show: false
                },
                labelLine: {
                    show: false,

                },
                data: [
                    100
                ],
            },
            {
                type: 'pie',
                radius: ['92%', '100%'],
                hoverAnimation: false,
                labelLine: {
                    show: false,

                },
                color: ['#00000000'],
                data: [
                    {
                        value: dataList, name: '', percent: '20%', itemStyle: {
                            color: color
                        }
                    },
                    { value: 80 },
                ]
            }
        ],
    };
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const industryEcharts = (options) => {
    let { chartDom,dataList,nameList,name,unit } = options;
    if (!chartDom) return;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    let option = {
        tooltip: {
            trigger: "axis",
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0 ,
            textStyle: {
                color:'#FFFFFF'
            }
        },
        legend: {
            right: 'center',
            top: 0,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            itemGap: 37,
           
            data:[name],
            textStyle: {
                fontSize: 12,
                fontFamily: 'Microsoft YaHei',
                fontWeight: 'normal',
                color: '#FFFFFFA8'
            }
        },
        xAxis: {
            data: nameList,
            splitLine: {
                show: false
            },
            axisLine: {
                show: false

            },
            axisTick: {
                show: false

            }
        },

        yAxis: {
            name:unit,
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        },
        grid: {
            top: '10%',
            bottom: '10%',
            left: '5%',
            right: '5%'
        },
        color: ['#11CABE', '#246CF9','#8371F2'],
        series: [
            {
                name: name,
                type: "bar",
                barWidth: 35,
                data:dataList,
                itemStyle: {
                    borderRadius: [10, 10, 10, 10],
                }
            }]
    }

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}

const lineEchart = (options) => {
    let { chartDom ,unit,
        monthList,
        list1,
        list2,
        list3,
        list4,
        list5,
        list6,
        name1,
        name2,
        name3,
        name4,
        name5,
        name6
    } = options;
    if (!chartDom) return;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    var pattern2 = new RegExp("[A-Za-z]+")
    var normalColor = "rgba(255,255,255,.5)";
    let option = {

        title: {
            textStyle: {
                fontSize: 14
            }
        },
        legend: {
            itemGap: 5,
            icon: 'circle',
            itemWidth: 8, // 设置宽度
            itemHeight: 8,
            top: '0',
            left:pattern2.test(name1)?'center':'center' ,
            textStyle: {
                color: '#ffffff'
            },
            data: [name1,name2,name3,name4,name5,name6]
        },
        tooltip: { // 提示框组件
            trigger: 'axis',
            show: true,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            valueFormatter: (value, name) => {
                console.log(value, name)
               return value&&Number(value)
            },
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            },
            padding: 10,
        
        },
        grid: {
            left: '10%',
            right: '10%',
            top: '17%',
            bottom: '13%',
        },
        xAxis: [{
            type: 'category',
            boundaryGap: true, // 坐标轴两边留白
            
            axisLabel: {
                color: normalColor,
                fontSize: 15,
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    type: "solid",
                    color: normalColor
                }
            },
            data: monthList
        }],
        yAxis: [{
            name: unit,
            nameTextStyle: {
                fontSize: 15,
            },
            type: 'value',
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                color: normalColor,
                fontSize: 15,
                // margin: 25,
                formatter: '{value}'
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#B6B7BC33',
                    type: 'dashed',
                }
            },
        }, {
            name: "%",
            nameTextStyle: {
                fontSize: 15,
            },
            type: 'value',
            min: 0,
            axisLine: {
                show: false,
                lineStyle: {
                    color: normalColor,
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: normalColor,
                fontSize: 15,
            },
            splitLine: {
                show: false,
            },
        },],
        series: [
            {
            name: name1,
            type: 'bar',
            yAxisIndex: 0,
            stack: '1',
            zlevel: 2,
            barGap: '50%',
            barWidth: '30%',
            barCategoryGap: "50%",
            color: normalColor,
            itemStyle: {
                normal: {
                    color: '#11CABE',
                    label: {
                        show: false,
                    }
                }
            },
            data: list1
        },
        {
            name: name2,
            type: 'bar',
            yAxisIndex: 0,
            stack: '1',
            zlevel: 2,
            barGap: '50%',
            barWidth: '30%',
            barCategoryGap: "50%",
            color: normalColor,
            itemStyle: {
                normal: {
                    color: '#C2C974',
                    borderRadius: [0, 0, 0, 0],
                    label: {
                        show: false,
                    }
                }
            },
            data: list2
            },
            {
                name: name3,
                type: 'bar',
                yAxisIndex: 0,
                stack: '1',
                zlevel: 2,
                barGap: '50%',
                barWidth: '30%',
                barCategoryGap: "50%",
                color: normalColor,
                itemStyle: {
                    normal: {
                        color: '#A98FC6',
                        borderRadius: [0, 0, 0, 0],
                        label: {
                            show: false,
                        }
                    }
                },
                data: list3
            },
            {
                name: name4,
                type: 'bar',
                yAxisIndex: 0,
                stack: '1',
                zlevel: 2,
                barGap: '50%',
                barWidth: '30%',
                barCategoryGap: "50%",
                color: normalColor,
                itemStyle: {
                    normal: {
                        color: '#5A8F74',
                        borderRadius: [0, 0, 0, 0],
                        label: {
                            show: false,
                        }
                    }
                },
                data: list4
            },
            {
                name: name5,
                type: 'bar',
                yAxisIndex: 0,
                stack: '1',
                zlevel: 2,
                barGap: '50%',
                barWidth: '30%',
                barCategoryGap: "50%",
                color: normalColor,
                itemStyle: {
                    normal: {
                        color: '#C99B70',
                        borderRadius: [0, 0, 0, 0],
                        label: {
                            show: false,
                        }
                    }
                },
                data: list5
            },
        {
            name: name6,
            type: 'line',
            yAxisIndex: 1,
            zlevel: 2,
            smooth: true,
            symbol: 'none',
            lineStyle: {
                width: 3
            },
            itemStyle: {
                normal: {
                    color: '#8371F2',

                }
            },
            areaStyle: {
                opacity: 0.2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                        offset: 0,
                        color: '#7387AE'
                    },
                    {
                        offset: 1,
                        color: '#3A4A69'
                    }
                ])
            },
            data: list6
        },
       
        ]
    };
    myChart && option && myChart.setOption(option);
    // curMap = {
    //     mapCode: mapCode,
    //     mapName: name
    // };
    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
export {
    businessOpportunityManagementEcharts,
    lineEcharts,
    workOrderStatisticsEcharts,
    opportunityEcharts,
    scheduleEcharts,
    pieEcharts,
    industryEcharts,
    lineEchart
}
